type CardPictureOptions = {
  src: string;
};

export const CardPicture = ({ src }: CardPictureOptions) => (
    <img src={src} alt="" className="rounded-3xl"></img>
);
